/* Maison Ronron v13 bis « ultime » : pages secondaires (préfixe ps).
   Après l'envoi d'un formulaire de contact, le message de réussite ou d'erreur reçoit le focus (lecteurs d'écran,
   clavier) et vient à l'écran sous la barre de navigation. Le formulaire de rétractation garde son propre script
   (identique à la v12). Sans JavaScript : messages visibles, rien ne bouge. */
(function () {
  'use strict';
  const demarrer = () => {
    const msg = document.querySelector('[data-ps-focus]');
    if (!msg) return;
    msg.closest('.revele')?.classList.add('vu');
    msg.focus({ preventScroll: true });
    msg.scrollIntoView({ block: 'center', behavior: window.MR14 && !window.MR14.reduit ? 'smooth' : 'auto' });
  };
  if (window.MR14) window.MR14.pret(demarrer);
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
